import { createStyles, makeStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import React from "react";
import CircleLoader from "./CircleLoader";

const useStyles = makeStyles(() =>
  createStyles({
    button: {
      marginBottom: 3,
      marginTop: 3,
    },
  })
);

type SubmitButtonProps = {
  disabled?: boolean;
  tabIndex?: any;
  type?: "submit" | "button" | "reset";
  color?: "default" | "inherit" | "primary" | "secondary";
  loading?: boolean;
  size?: "small" | "medium" | "large";
  onClick?: () => void;
  className?: string;
  children?: React.ReactNode;
};

const SubmitButton = ({
  color,
  disabled,
  loading,
  size,
  onClick,
  className,
  children,
  tabIndex,
  type,
}: SubmitButtonProps) => {
  const classes = useStyles();
  const addClasses = className ? className : "";
  return (
    <Button
      className={classes.button + " " + addClasses}
      type={type || "submit"}
      tabIndex={tabIndex}
      size={size ? size : "medium"}
      variant="contained"
      disableElevation
      fullWidth
      disabled={disabled}
      color={color || "default"}
      onClick={onClick}
    >
      {children}
      {loading ? <CircleLoader /> : null}
    </Button>
  );
};

export default SubmitButton;
